import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import DividendCalculatorPage from "@/components/tools/DividendCalculatorPage";

const DividendenRechner = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (!localStorage.getItem("i18nextLng")) {
      i18n.changeLanguage("de");
    }
  }, [i18n]);
  return <DividendCalculatorPage locale="de" />;
};

export default DividendenRechner;
